export const shouldReportErrorMonitor = (err) => err?.httpStatus !== 403;
